<template>
  <div class="bg-nexus-dark dashboard-root">
    <v-btn
      v-if="!$vuetify.breakpoint.lgAndUp"
      fab
      fixed
      bottom
      right
      color="white"
      light
      style="z-index: 100"
      @click="drawer = !drawer"
    >
      <v-icon color="black">{{ drawer ? "mdi-close" : "mdi-menu" }}</v-icon>
    </v-btn>

    <v-row no-gutters class="flex-nowrap flex-grow-1 overflow-hidden position-relative">
      <!-- En pantallas chicas el drawer es temporal Y absoluto: si quedara en el
           flujo, cerrado seguiría ocupando sus 280px como un hueco vacío. -->
      <v-navigation-drawer
        v-model="drawer"
        :permanent="$vuetify.breakpoint.lgAndUp"
        :temporary="!$vuetify.breakpoint.lgAndUp"
        :absolute="!$vuetify.breakpoint.lgAndUp"
        width="280"
        class="sidebar-border bg-sidebar-premium flex-shrink-0"
        floating
      >
       <div class="pa-6 d-flex flex-column">

  <!-- Empresa -->
  <div class="mb-6">
    <span class="text-caption grey--text">EMPRESA</span>
    <div class="white--text font-weight-bold">
      {{ empresaNombreUpperCase }}
    </div>
  </div>

  <v-divider class="divider-subtle mb-6"></v-divider>

  <!-- Título claro -->
  <div class="mb-4">
    <span class="text-overline grey--text">
      OPERAR SUCURSAL
    </span>
    <p class="text-caption grey--text mt-1">
      Seleccioná una sucursal para ventas, caja y stock
    </p>
  </div>

  <!-- Lista -->
  <SucursalListCard @seleccionar="setSucursal" />
</div>
      </v-navigation-drawer>

      <div class="flex-grow-1 bg-canvas-premium overflow-y-auto custom-scroll">
        <v-row no-gutters class="flex-nowrap min-width-0">
          <v-col class="pa-6 pa-md-10 flex-grow-1">
           <header class="mb-10">

  <h1 class="text-h3 white--text font-weight-thin mb-2">
    {{ actualizarSaludo() }},
    <span class="font-weight-black">
      {{ $store.state.auth.user.username }}
    </span>
  </h1>

  <omni-bar hero class="mt-6" placeholder="Buscá una pantalla, un producto, un cliente o escribí qué querés hacer…"></omni-bar>
  <p class="text-caption grey--text mt-3 mb-0">
    Administrá productos, clientes, compras y reportes a nivel global.
    Para operar ventas o caja, ingresá a una sucursal.
  </p>

</header>

            <v-alert
              v-if="suscripcion && !suscripcion.vigente"
              type="warning"
              dense
              outlined
              class="mb-6"
              icon="mdi-alert-circle-outline"
            >
              Tu suscripción no está vigente. Contactá al administrador para renovarla.
              <v-btn x-small text color="warning" :to="{ name: 'empresa.miPlan' }">Ver mi plan</v-btn>
            </v-alert>

            <v-row dense>
              <v-col
                v-for="modulo in modulosHabilitados"
                :key="modulo.id"
                cols="12"
                sm="6"
                xl="4"
                class="pa-3"
              >
                <v-card
                  flat
                  class="pa-7 rounded-xl border-glass bg-card-premium h-100 transition-lift"
                >
                  <div class="d-flex align-center mb-6">
                    <div class="modulo-icon-box-sobrio mr-4">
                      <v-icon color="white" size="18">{{ modulo.icon }}</v-icon>
                    </div>
                    <span
                      class="text-subtitle-1 font-weight-bold white--text tracking-tighter"
                      >{{ modulo.titulo }}</span
                    >
                  </div>

                  <div class="d-flex flex-column">
                    <v-btn
                      v-for="link in modulo.links"
                      :key="link.text"
                      @click="$router.push({ name: link.to })"
                      text
                      class="link-premium-btn mb-1 justify-start"
                    >
                      <v-icon x-small class="mr-3 opacity-3"
                        >mdi-circle-small</v-icon
                      >
                      <span class="grey--text text--lighten-1">{{
                        link.text
                      }}</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="$vuetify.breakpoint.lgAndUp"
            class="novedades-column-fixed pa-8 flex-shrink-0"
            :class="{ 'novedades-column--nuevas': novedadesPendientes }"
          >
            <div class="d-flex align-center mb-4">
              <v-icon :color="novedadesPendientes ? '#e3b08a' : 'white'" class="mr-3" size="18"
                >mdi-bell-outline</v-icon
              >
              <span
                class="text-overline white--text font-weight-black letter-spacing-1"
                >NOVEDADES</span
              >
              <span v-if="novedadesPendientes" class="novedades-chip">Nuevo</span>
            </div>
            <!-- Hasta que no las marque como vistas, la columna queda resaltada -->
            <div v-if="novedadesPendientes" class="novedades-aviso">
              <span>Cambiamos varias pantallas. Esto es lo que vas a notar.</span>
              <v-btn x-small depressed color="#BA6B30" class="white--text" @click="marcarNovedadesVistas">Entendido</v-btn>
            </div>

            <div class="novedades-container">
              <div v-for="(novedad, i) in novedades" :key="i" class="mb-6">
                <div class="mb-2">
                  <v-chip
                    x-small
                    outlined
                    color="grey lighten-1"
                    class="font-weight-black"
                    style="font-size: 0.6rem"
                    >{{ novedad.tag }}</v-chip
                  >
                </div>
                <p
                  class="grey--text text--lighten-1 text-caption font-weight-light line-height-tight mb-0"
                >
                  {{ novedad.texto }}
                </p>
                <v-divider
                  class="divider-subtle mt-5"
                  v-if="i !== novedades.length - 1"
                ></v-divider>
              </div>
            </div>


           
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<style scoped>
.dashboard-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.position-relative {
  position: relative;
}
/* BLOQUEO DE ANCHOS */
.novedades-column-fixed {
  width: 260px !important; /* Reducido de 320px a 260px */
  min-width: 260px !important;
  max-width: 260px !important;
  border-left: 1px solid rgba(255, 255, 255, 0.05) !important;
  background-color: rgba(0, 0, 0, 0.05);
  transition: background-color 0.3s, border-color 0.3s;
}
.novedades-column--nuevas {
  border-left: 2px solid rgba(186, 107, 48, 0.7) !important;
  background: linear-gradient(180deg, rgba(186, 107, 48, 0.1), rgba(186, 107, 48, 0.02) 40%) !important;
}
.novedades-chip {
  margin-left: 8px;
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #e3b08a;
  border: 1px solid rgba(227, 176, 138, 0.6);
  border-radius: 999px;
  padding: 1px 8px;
}
.novedades-aviso {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  font-size: 12px;
  color: #cfcfcf;
  margin-bottom: 18px;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.min-width-0 {
  min-width: 0;
}

/* Estética General */
.bg-nexus-dark {
  background-color: #0f0f0f !important;
}
.bg-sidebar-premium {
  background-color: #0f0f0f !important;
}
.bg-canvas-premium {
  background: radial-gradient(circle at top right, #0f0f0f 0%, #0f0f0f 100%);
}
.sidebar-border {
  border-right: 1px solid rgba(255, 255, 255, 0.03) !important;
}
.divider-subtle {
  border-color: rgba(255, 255, 255, 0.05) !important;
}
.border-glass {
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
}
.bg-card-premium {
  background: rgba(255, 255, 255, 0.01) !important;
  backdrop-filter: blur(10px);
}
.modulo-icon-box-sobrio {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}
.glass-avatar {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.link-premium-btn {
  text-transform: none !important;
  font-weight: 300 !important;
  color: #84a6d1 !important;
  height: 30px !important;
}
.link-premium-btn:hover {
  background: rgba(255, 255, 255, 0.03) !important;
  padding-left: 12px !important;
  color: white !important;
}
.transition-lift:hover {
  border-color: rgba(255, 255, 255, 0.15) !important;
}
.status-dot {
  width: 6px;
  height: 6px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.custom-scroll::-webkit-scrollbar {
  width: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #1a1a1a;
  border-radius: 10px;
}
.tracking-tighter {
  letter-spacing: -1px !important;
}
.letter-spacing-2 {
  letter-spacing: 2px !important;
}
.uppercase {
  text-transform: uppercase;
}
.opacity-3 {
  opacity: 0.3;
}
</style>

<script>
import { novedadesRecientes, versionActual } from "@/changelog";
import modulosEmpresa, { moduloHabilitado } from "@/config/modulosEmpresa";
import OmniBar from "@/components/empresa/OmniBar.vue";
import SucursalListCard from "@/components/empresa/sucursales/SucursalListCard.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "EmpresaDashboard",
  components: { SucursalListCard, OmniBar },
  data: () => ({
    drawer: null,
    empresaNombre: "Ferretería Industrial",
    // Salen del changelog, filtradas por audiencia: al cliente no le importa
    // lo que sólo mira administración.
    novedades: novedadesRecientes("todos"),
    novedadesPendientes: false,
    todosLosModulos: modulosEmpresa,
  }),
  computed: {
    ...mapGetters("empresa", ["empresa_nombre"]),
    ...mapState("auth", ["suscripcion"]),
    empresaNombreUpperCase() {
      return this.empresa_nombre.toUpperCase();
    },
    suscripcionVigente() {
      return this.suscripcion && this.suscripcion.vigente
    },
    modulosHabilitados() {
      if (!this.suscripcion || !this.suscripcion.vigente || !this.suscripcion.modulos.length) {
        return this.todosLosModulos
      }
      return this.todosLosModulos.filter(m => moduloHabilitado(m, this.suscripcion))
    },
  },
  watch: {
    // Al achicar la ventana el drawer deja de ser permanente: si quedó abierto
    // aprieta el contenido en vez de flotar. Se cierra al cruzar el breakpoint.
    "$vuetify.breakpoint.lgAndUp"(esGrande) {
      if (!esGrande) this.drawer = false;
    },
  },
  created() {
    try {
      this.novedadesPendientes = this.novedades.length > 0 && localStorage.getItem("novedades_vistas") !== versionActual();
    } catch (e) {
      this.novedadesPendientes = this.novedades.length > 0;
    }
  },
  methods: {
    marcarNovedadesVistas() {
      this.novedadesPendientes = false;
      try {
        localStorage.setItem("novedades_vistas", versionActual());
      } catch (e) {
        /* sin storage se vuelve a resaltar, no es grave */
      }
    },
    actualizarSaludo() {
      const hora = new Date().getHours();
      if (hora >= 6 && hora < 12) return "Buen día";
      if (hora >= 12 && hora < 19) return "Buenas tardes";
      return "Buenas noches";
    },
    async setSucursal(sucursal) {
      const { success } = await this.$store.dispatch(
        "sucursales/validate_asignacion_sucursal",
        sucursal.uuid
      );
      if (success) {
        this.$router.push(`/sucursal/${sucursal.uuid}`);
      }
    },
  },
};
</script>